import { HOTEL_SKELETON_IMAGE } from '@/app/constants'
import Image from 'next/image'
import { FC } from 'react'

const HotelListItemPlaceholderSmall: FC = () => {
	return (
		<>
			<div className="hotel-card-placeholder flex flex-col bg-white rounded-4xl shadow-md border border-text-300">
				{/* Image column (mobile) */}
				<div className="w-full shrink-0 rounded-4xl overflow-hidden">
					<Image
						src={HOTEL_SKELETON_IMAGE}
						width={280}
						height={220}
						alt={'placeholder image'}
						className="animate-placeholder h-[170px] w-full rounded-4xl overflow-hidden object-cover"
					/>
				</div>

				{/* Content column (mobile) */}
				<div className="w-full flex flex-col justify-between px-4 py-3">
					<div>
						<div className="flex flex-col-reverse items-start">
							<div className="rtl:mr-0 rtl:ml-2 mr-2 w-full">
								<div className="hotel-card-placeholder__title h-5 bg-text-300 rounded-4xl w-3/4 mb-2"></div>
							</div>
						</div>
						<div className="flex items-center mb-2 flex-col justify-start items-start">
							<div className="flex h-3 w-full bg-text-300 rounded-4xl animate-placeholder"></div>
							<div className="flex items-center my-6">
								<div className="rounded w-4 h-4 bg-text-300 mr-1 rtl:mr-0 rtl:ml-1 animate-placeholder" />
								<div className="h-3 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
								<div className="h-3 w-[100px] bg-text-300 rounded-4xl animate-placeholder "></div>
							</div>
						</div>
					</div>

					<div className="flex border-t border-text-200 items-center justify-between py-3 rounded-4xl bg-white">
						<div className="flex flex-col">
							<div className="h-5 w-[110px] bg-text-300 rounded-4xl  animate-placeholder"></div>
							<div className="h-3 w-[140px] bg-text-300 rounded-4xl mt-2 animate-placeholder "></div>
							<div className="h-3 w-[120px] bg-text-300 rounded-4xl mt-2 animate-placeholder "></div>
						</div>
						<div className="rounded-4xl w-[124px] h-11 bg-text-300 mr-1 animate-placeholder" />
					</div>
				</div>
			</div>
		</>
	)
}

export default HotelListItemPlaceholderSmall
